/**
 * Created by vtbelo on 05.05.2021
 */

const ChestPrizeProbWindow = CleverappsWindow.extend({
    onWindowLoaded: function (unit, probs) {
        this.unit = unit;
        this.probs = probs;
        
        this._super({
            title: Messages.get(`Units.${unit.code}.stage${unit.stage + 1}.name`),
            name: "ChestPrizeProbWindow",
            content: this.createContent(),
            closeButton: true,
            foreground: bundles.windows.frames.window_foreground_png
        });
    },

    generateContains: function () {
        const contains = [];
        const styles = cleverapps.styles.ChestPrizeProbWindow.prize;

        this.probs.types.forEach((unit) => {
            const prizeBackground = new cc.Scale9Sprite(bundles.merge.frames.icon_background_light);
            prizeBackground.setContentSize2(styles.background);

            const prizeIcon = UnitView.getUnitImage(unit, { preferStatic: true });
            prizeIcon.clearTrack && prizeIcon.clearTrack(0);
            prizeIcon.setAnchorPoint(0.5, 0.5);
            prizeIcon.setAlignment(prizeBackground.width / 2, prizeBackground.height / 2);
            cleverapps.UI.fitToBox(prizeIcon, styles.icon);

            prizeBackground.addChild(prizeIcon);

            const text = cleverapps.UI.generateOnlyText(
                unit.amount ? `x${unit.amount}` : `${unit.prob}%`,
                cleverapps.styles.FONTS.UNIT_PROB
            );
            text.setAlignment(styles.probText);
            prizeBackground.addChild(text);

            contains.push(prizeBackground);
        });

        return contains;
    },

    generateSameItemsText: function () {
        if (this.probs.minAmount === this.probs.maxAmount) {
            return;
        }
        return cleverapps.UI.generateOnlyText(Messages.get("ChestContainSameItems"), cleverapps.styles.FONTS.SAME_ITEMS_TEXT);
    },

    generateMayContainText: function () {
        if (this.probs.minAmount === this.probs.maxAmount) {
            return cleverapps.UI.generateOnlyText(Messages.get("ChestContainAmountFixed", {
                amount: this.probs.minAmount
            }), cleverapps.styles.FONTS.DARK_TEXT);
        }

        return cleverapps.UI.generateOnlyText(Messages.get("ChestContainAmount", {
            min: this.probs.minAmount,
            max: this.probs.maxAmount
        }), cleverapps.styles.FONTS.DARK_TEXT);
    },

    generateMayContain: function () {
        const styles = cleverapps.styles.ChestPrizeProbWindow;

        const container = new cleverapps.Layout(this.generateContains(), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.containScroll.margin,
            padding: styles.containScroll.padding
        });

        const mayContain = new cleverapps.UI.ScrollView(container, {
            scrollBarEnabled: false,
            direction: cleverapps.UI.HORIZONTAL
        });
        mayContain.setContentSize2(styles.containScroll.width, container.height + 2);
        mayContain.scrollToDefault();

        return mayContain;
    },

    createContent: function () {
        const styles = cleverapps.styles.ChestPrizeProbWindow;

        const unit = new UnitOnCell(this.unit, {
            shining: true
        });

        unit.setScale(styles.chest.scale);

        return new cleverapps.Layout([
            unit,
            this.generateMayContainText(),
            this.generateMayContain(),
            this.generateSameItemsText()
        ], {
            margin: styles.margin,
            padding: styles.padding
        });
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SAME_ITEMS_TEXT: {
        size: 23,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.ChestPrizeProbWindow = {
    margin: 30,

    prize: {
        background: {
            width: 200,
            height: 200
        },
        icon: {
            width: 160,
            height: 160,
            maxScale: 1.6
        },
        probText: {
            x: { align: "right", dx: -10 },
            y: { align: "bottom" }
        }
    },

    padding: {
        left: -60,
        right: -60,
        top: 0,
        bottom: 0
    },

    chest: {
        scale: 1.6
    },

    containScroll: {
        width: 1400,
        margin: 14,
        padding: {
            x: 40,
            y: 0
        }
    }
};
